import axios from "axios";
import {
    API_AUTH_COR_ID_BY_EMAIL,
    API_AUTH_COR_ID_GET_QR,
    API_AUTH_GET_FINANCE_TOKEN,
    API_AUTH_ME,
    API_AUTH_REFRESH_COR_ID_URI,
    API_AUTH_REFRESH_FINANCE_URI
} from "../constants/api.constant";
import {UserToken} from "../types";
import {StorageService} from "./index";


export default class AuthService {
    static async loginByEmail(data: any){
        const formData = new FormData();
        formData.append('username', data.username)
        formData.append('password', data.password)
        return await axios.post(API_AUTH_COR_ID_BY_EMAIL, formData)
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }

    static async getQr(email: string): Promise<{deep_link: string; session_token: string}>{
        return await axios.post(API_AUTH_COR_ID_GET_QR, {email})
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }

    static async getTokens(): Promise<UserToken>{
        return await axios.post(API_AUTH_GET_FINANCE_TOKEN)
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }


    static async refreshToken() {
        return await axios.post(API_AUTH_REFRESH_FINANCE_URI, {
            refresh_token: StorageService.refreshToken
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }


    static async refreshCorIdToken() {
        return await axios.get(API_AUTH_REFRESH_COR_ID_URI, {
            headers: {

            }
            // refresh_token: StorageService.refreshCorIdToken
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }


    static async getCurrentUser() {
        return await axios.get(API_AUTH_ME)
            .then(response => response.data)
            .catch(e => Promise.reject(e?.data || e));
    }
}

